import { createFileRoute } from "@tanstack/react-router";
import { SearchParams } from "./-data/model";
import { Loading } from "@/layouts/loading";
import Component from "./-components/component";
import { pharmacyClient } from "@/connect";

export const Route = createFileRoute("/(inventory)/branch/_layout/reports/items-reorder-report/")({
  component: Component,
  validateSearch: SearchParams,
});
